<template>
  <div class="hello">
    <div class="navmenu">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item style="font-family: HarmonyOS_Sans_Black !important;" index="0">首页</el-menu-item>
        <el-menu-item style="font-family: HarmonyOS_Sans_Black !important;" index="1">关于我们</el-menu-item>
        <el-menu-item style="font-family: HarmonyOS_Sans_Black !important;" index="2">产品业务</el-menu-item>
        <el-menu-item style="font-family: HarmonyOS_Sans_Black !important;" index="3">联系我们</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TAG',
  data() {
    return {
      bannerHeight: " ",
      activeIndex: '0',

    }
  },
  mounted() {
       if(sessionStorage.getItem("tagIndex")!=null ||sessionStorage.getItem("tagIndex")!=undefined){
         this.activeIndex = sessionStorage.getItem("tagIndex")
       }
  },
  computed:{
    tagIndex(){
      return this.$store.state.tagIndex
    }
  },
  watch:{
    tagIndex:{
      immediate:true,
      handler(newValue){
        if(this.$store.state.tagIndex != this.activeIndex){
           this.activeIndex = newValue
        }
      }
    }
  },
  methods: {
    handleSelect(key) {
      this.$store.dispatch('changeDispatch',key)
      // console.log("state===="+this.$store.state.tagIndex)
      sessionStorage.setItem("tagIndex",key)
       switch (key){
         case "0":
           this.$router.push("/homeOne",()=>{
           })
           break;
         case "1":
           this.$router.push("/homeTwo",()=>{})
           break;
         case "2":
           console.log("2222")
           this.$router.push("/homeThird",()=>{})
           break;
         case "3":
           this.$router.push("/homeFour",()=>{})
           break;
       }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$back-color: #FFFFFF;
$font-color: #000000;
$main-color: #E62129;

.hello {
  width: 100%;
  height: auto;
}

.navmenu {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  font-size: 17px;
  font-weight: lighter;
  list-style: none;
  position: fixed;
  top: 26px;
  right: 48px;
  background-color: $back-color;
  z-index: 999;
  padding: 8px 24px 16px 24px;
  border-radius: 8px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);

  .el-menu.el-menu--horizontal {
    border-bottom:0px;

    .el-menu-item {
      height: auto;
      color: $font-color;
      height: auto;
      line-height: auto;
      padding: 0px;
      margin: 0px 10px;
    }

    .el-menu-item.is-active {
      border-bottom: 2px solid $main-color;
    }
  }
}
</style>
